import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { selectClients } from '../../store/slices/clients.slice';
import { ClientDto } from '../../commonTypes/client.types';

export const useClient = (clientId: string | undefined) => {
    const clients = useSelector<RootState, ClientDto[]>(selectClients);
    if (!clientId) return;
    return clients.find(client => client.id === clientId);
};
